import { ControlButton, type ControlButtonProps } from "@/components/patterns/control-button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

/**
 * Toolbar placeholder for a feature that is not built yet. The button is
 * disabled, but a native disabled button swallows pointer events so `title`
 * never shows; the wrapping span receives the hover and opens the tooltip.
 */
export function UnavailableControl({
  reason,
  children,
  ...props
}: Omit<ControlButtonProps, "disabled" | "title"> & { reason: string }): React.ReactElement {
  return (
    <Tooltip>
      <TooltipTrigger render={<span className="inline-flex" />}>
        <ControlButton controlSize="toolbar" disabled {...props}>
          {children}
        </ControlButton>
      </TooltipTrigger>
      <TooltipContent>{reason}</TooltipContent>
    </Tooltip>
  );
}
